/*=========================================================================================
  File Name: moduleCompanyState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	uploads: [],
	upload: null,
	equivalents: {
		cx: null,
		cy: null,
		identification: null,
		demand: null,
		end_hour_window: null,
		init_hour_window: null,
		skills: null,
		time_service: null,
		other_fields: [],
	},
	skills: [],
	uploadedFiles: [],
	pagination: {
		next_page: 0,
		total_pages: 0,
		total_records: 0,
		current_page: 1,
	},
	datarutas_file: false,
	capacityNames: [],
};
